import { render, staticRenderFns } from "./RouterViewWithBreadcrumbsHolder.vue?vue&type=template&id=51173206&scoped=true&"
import script from "./RouterViewWithBreadcrumbsHolder.vue?vue&type=script&lang=ts&"
export * from "./RouterViewWithBreadcrumbsHolder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51173206",
  null
  
)

export default component.exports